import { GROUPS, PREFIX_PROXY } from '@/service/apiConf';
import { get } from '@/service/request';

/** 获取保密字典 */
export const getSecretKeymaps = (cluster: string, params?: any): Promise<any> =>
  get(`${PREFIX_PROXY.vapis(GROUPS.secret)}/secrets`, params);

/** 获取配置字典 */
export const getConfigKeymaps = (cluster: string, params?: any): Promise<any> =>
  get(`${PREFIX_PROXY.vapis(GROUPS.configmap)}/configmaps`, params);
